export class SessionExpiredError extends Error {
  constructor() {
    super("Session expired, redirecting to the login page")
    this.name = "SessionExpiredError"
  }
}

// True for an auth failure the app has already answered by redirecting to the
// login page, so the rejection that follows is bookkeeping, not a bug.
export const isHandledAuthFailure = (error) =>
  error instanceof SessionExpiredError ||
  error?.name === "SessionExpiredError" ||
  error?.response?.status === 401
